// Configuration file with API credentials
// Replace placeholder values with your actual credentials

export const config = {
  // Google Calendar API Configuration
  // 1. Go to Google Cloud Console: https://console.cloud.google.com
  // 2. Create/select a project
  // 3. Enable Google Calendar API
  // 4. Create API Key in Credentials section
  // 5. Make your calendar public (Settings > Access permissions > Make available to public > See only free/busy)
  googleCalendar: {
    apiKey: 'AIzaSyDufyrRVADK8alrvoq8iyveFcJOhtMJl0g',
    calendarId: 'info@galific.com', // Usually your email or calendar ID
    timeZone: 'Asia/Kolkata',
    meetingDuration: 30, // minutes
  },

  // Google Sheets Webhook Configuration
  // Deploy the Apps Script below and paste the web app URL here
  // See SETUP.md for the Apps Script code
  googleSheets: {
    webhookUrl: 'https://script.google.com/macros/s/AKfycbzyY8W1YrybzhCHpoRV9ZjqsBNVIKz4qU0HJ1IRC0msFQVjRY2dOyDqrgThN6DSzyOpFg/exec',
  },

  // WhatsApp Business API Configuration
  // Get these from your WhatsApp Business Platform account
  whatsAppBusiness: {
    apiUrl: 'https://graph.facebook.com/v22.0',
    phoneNumberId: 'YOUR_PHONE_NUMBER_ID_HERE',
    accessToken: 'YOUR_WHATSAPP_ACCESS_TOKEN_HERE',
    templateName: 'booking_confirmation', // Your approved template name
  },

  // Galific branding
  branding: {
    companyName: 'Galific Solutions',
    logo: '/logo.png',
    primaryColor: '#1a1a2e',
    secondaryColor: '#16213e',
    accentColor: '#0f3460',
    backgroundColor: '#faf9f6',
    textColor: '#1a1a2e',
  },

  // Funnel settings
  funnel: {
    title: 'Find the right AI tool for your business',
    subtitle: 'Answer a few questions and discover automation solutions tailored for you',
  }
};

export default config;
